import React from 'react';
import {Table, Button, Input} from 'antd';
import Info from '../Detail/Info';

class GuestList extends React.Component {
    constructor(props) {
        super();
    }

    columns = [
        {
            title:"头像",
            dataIndex:"photo",
            render:(photo, record)=>{
                return <Info style={{width:80,height:80}} tip="170x210" showProgress={false} useLabel={false} type="upload" value={photo} onChange={this.setKeyValue.bind(this, record, 'photo')} />;
            }
        },
        {
            title:"姓名",
            dataIndex:"name",
            render:(name, record)=>{
                return <Info type="text" value={name} useLabel={false} onChange={this.setKeyValue.bind(this, record, 'name')} />;
            }
        },
        {
            title:"介绍",
            dataIndex:"intro",
            render:(intro, record)=>{
                return <Info type="text" value={intro} useLabel={false} onChange={this.setKeyValue.bind(this, record, 'intro')} />;
            }
        },
        {
            title:"操作",
            render:(field, record, index)=>{
                return <a  onClick={()=>this.deleteHandler(index)}>删除</a>;
            }
        }
    ];

    setKeyValue(record, key, val) {
        let {onChange, value} = this.props;

        var target = value.find(it=>it.index == record.index);
        target[key] = val;

        onChange(value);
    }

    deleteHandler = (index)=>{
        let {onChange, value} = this.props;

        value = value instanceof Array ? value : [];
        if(value[index]) {
            value.splice(index, 1);
        }

        onChange(value);
    }

    addOne = ()=>{
        let {onChange, value} = this.props;

        value = value instanceof Array ? value : [];
        value.push({
            index:value.length+1,
            photo:"",
            name:"",
            intro:""
        });

        onChange(value);
    }

    render() {
        let {value} = this.props;
        value = value instanceof Array ? value : [];
        value = value.filter(it=>!!it);

        return <div className="guestlist">
            <Table columns={this.columns}
                dataSource={value}
                rowKey={"index"}
                footer={()=>(<a  onClick={this.addOne}>添加一行</a>)}
            />
        </div>;
    }
}

export default GuestList;



// WEBPACK FOOTER //
// ./src/components/Select/GuestList.js